import { Col, Popover, Row, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import SectionCard from "./SectionCard";
import EditPenIcon from "../../../assets/images/editPenn.svg";
import PhoneIconSvg from "../../../assets/images/Phone.svg"
import EmailIconSvg from "../../../assets/images/email.svg"
import { EditPennIcon, EmailIcon, LocationIcon, PendingIcon, PhoneIcon } from "../../common/CustomIcon";
import AddressInfo from "../../components/common/AddressInfo";
import Button_v2 from "./Button_v2";
import CopyableContent from "../../components/common/CopyableContent";

const OrderDetailsView = ({ updateViewType, details = {}, account = {}, history, isShipper = false, showActions = true }) => {
    const emptyText = 'Not available'
    const columnRef = useRef(null);
    const textRef = useRef(null);
    const [showTooltip, setShowTooltip] = useState(false)

    useEffect(() => {
        const textOverflow = () => {
            //scrollWidth
            if (columnRef.current < textRef.current) {
                setShowTooltip(columnRef.current.offsetWidth < textRef.current.offsetWidth)
                console.log(columnRef.current.offsetWidth, textRef.current.offsetWidth, '1')
            }
        }
        textOverflow()
    })

    // const overflowTooltip = ()

    const accountContent = (
        <div>
            <div className="content-div">
                <Row gutter={[8, 8]} align="middle" type="flex">
                    <Col>
                        <EmailIcon />
                    </Col>
                    <Col className="text-blue text-col">{account.email || emptyText}</Col>
                </Row>
                <Row gutter={[8, 8]} align="middle" type="flex">
                    <Col>
                        <LocationIcon />
                    </Col>
                    <Col className="text-blue">{account?.address ? <AddressInfo address={account.address} /> : ''}</Col>
                </Row>
                <Row gutter={[8, 8]} align="middle" type="flex">
                    <Col>
                        <PhoneIcon />
                    </Col>
                    <Col className="text-blue">{account.phone_number || 'N/A'}</Col>
                </Row>
                {/* <Row gutter={[8, 8]} align="middle" type="flex">
                    <Col>
                        <PendingIcon />
                    </Col>
                    <Col>8AM - 8PM ET</Col>
                </Row> */}
            </div>
            <div className="footer-div">
                <Row type="flex" gutter={16}>
                    <Col>
                        <Button_v2
                            onClick={() => history.push(`/accounts/${account.id}/settings`)}
                            className="outline medium-btn"
                            text={
                                <>
                                    <EditPennIcon color="#617AD6" />
                                    <span>Manage</span>
                                </>
                            }
                            />
                    </Col>
                    {/* <Col>
                        <Button_v2
                            // onClick={() => setOpenModal(false)}
                            className="outline medium-btn"
                            text="View Assigned Orders"
                        />
                    </Col> */}
                </Row>
            </div>
        </div>
    )


    return (
        <div className="order-details-view">
            <SectionCard>
                <Row className="order-details-content">
                    <Col span={12}>
                        <Row>
                            <Col span={4} className="col-one bold-text">Account</Col>
                            <Col span={20} className="col-two">
                                <Row className="blue-text margin-bottom-8">
                                    <Popover
                                        overlayClassName="account-details-popover"
                                        trigger="hover"
                                        placement="top"
                                        title={
                                            <Row type="flex" justify="space-between">
                                                <Col>
                                                    <div className="title-div-1">{account.account_name}</div>
                                                    <div className="title-div-2">{account.contact || emptyText}</div>
                                                </Col>
                                                <Col>
                                                    {account?.image?.url ?
                                                        <img src='' alt="logo" style={{ width: '48px', height: '48px', borderRadius: '50%' }} />
                                                        :
                                                        ''
                                                    }
                                                </Col>
                                            </Row>
                                        }
                                        content={accountContent}
                                    >
                                        {/* {account.account_name} */}
                                        <Col
                                            span={14}
                                            style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                        >
                                            <Tooltip
                                                title={account.account_name}
                                                overlayClassName="account-view-tooltip"
                                            >
                                                {account.account_name}
                                            </Tooltip>
                                        </Col>
                                    </Popover>
                                </Row>
                                <Row gutter={[2]} type="flex">
                                    <Col><img src={EmailIconSvg} /></Col>
                                    {/* <Col className="text-gray">{account.email || 'N/A'}</Col> */}
                                    <Col
                                        className="text-gray"
                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                        <Tooltip
                                            title={account.email || ''}
                                            overlayClassName="account-view-tooltip"
                                        >
                                            {account.email || 'N/A'}
                                        </Tooltip>
                                    </Col>
                                </Row>
                                <Row gutter={[2]} type="flex">
                                    <Col><img src={PhoneIconSvg} /></Col>
                                    {/* <Col className="text-gray">{account.phone_number || 'N/A'}</Col> */}
                                    <Col
                                        className="text-gray"
                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                        <Tooltip
                                            title={account.phone_number || ''}
                                            overlayClassName="account-view-tooltip"
                                        >
                                            {account.phone_number || 'N/A'}
                                        </Tooltip>
                                    </Col>
                                </Row>
                                <Row gutter={[2]} type="flex">
                                    <Col><LocationIcon color="#778490" width="16" height="16" /></Col>
                                    {/* <Col className="text-gray">{account?.address ? <AddressInfo address={account.address} /> : 'N/A'}</Col> */}
                                    <Col
                                        className="text-gray"
                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                        <Tooltip
                                            title={<AddressInfo address={account.address} /> || ''}
                                            overlayClassName="account-view-tooltip"
                                        >
                                            {account?.address ? <AddressInfo address={account.address} /> : 'N/A'}
                                        </Tooltip>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12}>
                        <Row>
                            <Col span={12} className="col-three">
                                <Row className="margin-bottom-8" type="flex">
                                    <Col span={10} className="bold-text">{I18n.t("general.warehouse")}</Col>
                                    {/* <Col span={14} className="text-gray">{details?.warehouse_name ? details?.warehouse_name : 'N/A'}</Col> */}
                                    <Col
                                        className="text-gray"
                                        span={14}
                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                        <Tooltip
                                            title={details?.warehouse_name || ''}
                                            overlayClassName="account-view-tooltip"
                                        >
                                            {details?.warehouse_name ? details?.warehouse_name : 'N/A'}
                                        </Tooltip>
                                    </Col>
                                </Row>
                                <Row type="flex">
                                    <Col span={10} className="bold-text">HAWB</Col>
                                    {/* <Col span={14} className="text-gray">{details?.hawb ? details?.hawb : 'N/A'}</Col> */}
                                    <Col
                                        className="text-gray"
                                        span={14}
                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                        <Tooltip
                                            title={details?.hawb || ''}
                                            overlayClassName="account-view-tooltip"
                                        >
                                            {details?.hawb ? <CopyableContent text={details.hawb}/> : emptyText}
                                        </Tooltip>
                                    </Col>
                                </Row>
                                <Row type="flex">
                                    <Col span={10} className="bold-text">Ref 1</Col>
                                    {/* <Col span={14} className="text-gray">{details?.reference_1 ? details?.reference_1 : emptyText}</Col> */}
                                    <Col
                                        className="text-gray"
                                        span={14}
                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                        <Tooltip
                                            title={details?.reference_1 || ''}
                                            overlayClassName="account-view-tooltip"
                                        >
                                            {details?.reference_1 ? <CopyableContent text={details.reference_1}/> : emptyText}
                                        </Tooltip>
                                    </Col>
                                </Row>
                                <Row type="flex">
                                    <Col span={10} className="bold-text">Other Ref</Col>
                                    {/* <Col span={14} className="text-gray">{details?.references ? details?.references : emptyText}</Col> */}
                                    <Col
                                        className="text-gray"
                                        span={14}
                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                        <Tooltip
                                            title={details?.references || ''}
                                            overlayClassName="account-view-tooltip"
                                        >
                                            {details?.references ? <CopyableContent text={details.references?.join(',')}/> : emptyText}
                                        </Tooltip>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12} className="col-four">
                                <Row className="margin-bottom-8" type="flex">
                                    <Col span={10} className="bold-text">Vehicle</Col>
                                    <Col
                                        span={14}
                                        className="text-gray"
                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                        <Tooltip
                                            title={details?.vehicle_name || ''}
                                            overlayClassName="account-view-tooltip"
                                        >
                                            {details?.vehicle_name ? details.vehicle_name : details?.vehicle_type ? details.vehicle_type : emptyText}
                                        </Tooltip>
                                    </Col>
                                    {/* <Col span={14} style={{overflow:'auto'}}className="text-gray">{details?.vehicle_type ? details?.vehicle_type : 'N/A'}</Col> */}
                                </Row>
                                <Row type="flex">
                                    <Col span={10} className="bold-text">MAWB</Col>
                                    {/* <Col span={14} className="text-gray">{details?.mawb ? details?.mawb : emptyText}</Col> */}
                                    <Col
                                        span={14}
                                        className="text-gray"
                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                        <Tooltip
                                            title={details?.mawb || ''}
                                            overlayClassName="account-view-tooltip"
                                        >
                                            {details?.mawb ?  <CopyableContent text={details.mawb}/> : emptyText}
                                        </Tooltip>
                                    </Col>
                                </Row>
                                <Row type="flex">
                                    <Col span={10} className="bold-text">Ref 2</Col>
                                    {/* <Col span={14} className="text-gray">{details?.reference_2 ? details?.reference_2 : emptyText}</Col> */}
                                    <Col
                                        span={14}
                                        className="text-gray"
                                        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    >
                                        <Tooltip
                                            title={details?.reference_2 || ''}
                                            overlayClassName="account-view-tooltip"
                                        >
                                            {details?.reference_2 ? <CopyableContent text={details.reference_2}/> : emptyText}
                                        </Tooltip>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {showActions && <img className="edit-icon" src={EditPenIcon} onClick={() => updateViewType('edit')} /> }
            </SectionCard>
        </div>
    )
}

export default OrderDetailsView

OrderDetailsView.propTypes = {
    setViewType: PropTypes.func,
    history: history

};

OrderDetailsView.defaultProps = {
    setViewType: () => { },
    history: () => { },

};